import React from 'react';
import { Box, Typography } from '@mui/material';
import analytics from '../../utils/analytics';

const RESULT_SCREEN_MIN_HEIGHT = 260;

type CreditLineErrorScreenProps = {
  message: string,
  pageName: string,
};

export default function CreditLineErrorScreen({ message, pageName }: CreditLineErrorScreenProps) {
  React.useEffect(() => {
    analytics.page('BNPL - REGISTRO - ERROR', pageName);
  }, [pageName]);

  return (
    <Box
      sx={{
        minHeight: RESULT_SCREEN_MIN_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        variant="h6"
        align="center"
        color="error"
      >
        {message}
      </Typography>
    </Box>
  );
}
